import styled from 'styled-components';

export const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: transparent; // 默认设置为透明
  // 移除背景色
  // background: #f2f3f4;
`;
